/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { type ImageSourcePropType } from 'react-native';

/**
 * Normalizes image source properties to be compatible with React Native Web/Next.js and Metro.
 * Next.js Webpack transpiles local image require() statements to an ES module object with .default or .src keys,
 * while React Native expects either a numeric asset registry ID or an object of the format { uri: string }.
 */
export const resolveImageSource = (
  source: unknown,
): ImageSourcePropType | undefined => {
  if (!source) return undefined;

  let actualSource: unknown = source;
  if (
    actualSource &&
    typeof actualSource === 'object' &&
    'default' in actualSource
  ) {
    actualSource = (actualSource as { default: unknown }).default;
  }

  if (actualSource && typeof actualSource === 'object') {
    if ('src' in actualSource) {
      return { uri: (actualSource as { src: string }).src };
    }
    if ('uri' in actualSource) {
      return { uri: (actualSource as { uri: string }).uri };
    }
  }

  if (typeof actualSource === 'string') {
    return { uri: actualSource };
  }

  return actualSource as ImageSourcePropType;
};
